import { type IPatientSchedule } from 'features/Home/interfaces/IInfoSchedule'

export const CANCELED_STATUS_CODES = [4, 13, 14]

export const sortCanceledSchedules = (schedules: IPatientSchedule[]): IPatientSchedule[] => {
  return [...schedules].sort((a, b) => {
    const aCanceled = CANCELED_STATUS_CODES.includes(a.status.code)
    const bCanceled = CANCELED_STATUS_CODES.includes(b.status.code)

    if (aCanceled && !bCanceled) return 1
    if (!aCanceled && bCanceled) return -1
    return 0
  })
}
